(function ($, _, root, undefined) {
    'use strict';

    var assetId = 'uc193-productlist';
    var productsHandlerUrl = root.R + 'Handlers/Public/ProductData.ashx';
    var pubSub = root.PubSub;

    var classes = {
        prodItem: 'js-uc193-item',
        mainImage: 'js-uc193-image',
        dimItem: 'js-uc193-dim-item',
        quickView: 'js-quick-view',
        buyBtn: 'BuyBtn',
        modifyQtyBtn: 'js-quantity-plus-minus-btn',
        editQtyBtn: 'js-edit-quantity-button',
        editQtyBtnReplacer: 'js-edit-quantity-button-replacer',
        quantityInput: 'QuantityTxb',
        fractionInput: 'js-uc193-fraction',
        overlayBtn: 'js-show-overlay',
        hideOverlayBtn: 'js-hide-overlay',
    };

// ReSharper disable StringLiteralTypo
    var dataNames = {
        itemId: 'itemid',
        productId: 'productid',
        imageId: 'imageid',
        tempOrderLineId: 'temp-order-line-id',
        quantityEditMode: 'quantity-edit-mode',
    }
// ReSharper restore StringLiteralTypo

    function controlsProvider($mainPanelControl) {
        return {
            $mainPanel: $mainPanelControl,
            $productListContainer: $mainPanelControl.find('.ProductListContainer'),
            $perPageItems: $mainPanelControl.find('.ItemsPerPage'),
            $pagingControls: $mainPanelControl.find('.ProductListPagerContainer'),
            $viewSettings: $mainPanelControl.find('.viewSettings'),
            $searchInput: $mainPanelControl.find('.js-product-list-search').find('.js-product-list-search-input'),
            $campaignFragmentContainer: $mainPanelControl.find('.js-fragment-container.Campaign'),

            $productContainers: null,

            init: function () {
                this.$productContainers = this.$productListContainer.find('.' + classes.prodItem);
            }
        }
    }

    function productListController($mainPanel, productListModel) {
        var model = productListModel;

        var controls = new controlsProvider($mainPanel);

        var currentState = {
            controlId: model.controlId,
            pageControlId: model.pageControlId,
            page: model.currentPage,
            perPage: model.perPage,
            isProductPage: model.isProductPage,
            showOnlyInStock: model.showOnlyInStock,
            totalItems: model.totalItems,
            filteredItemIds: undefined,
            filtersUrl: undefined,
            appliedFilters: undefined,
            searchTerm: model.searchTerm,
            sort: model.initSortingOption,
            showViewAll: model.showViewAll,
            loginUrl: root.R + model.loginUrl,
            isPreAppliedFilterProcessed: false,
            dataCache: {},
            timer: null,
        };

        var pubSubEventNames = {
// ReSharper disable StringLiteralTypo
            filtersChannelPrefix: 'frontend.productlist.filters.' + currentState.controlId,
            staticFilterChannelPrefix: 'frontend.productlist.staticfilter.' + currentState.controlId,
            refreshChannelPrefix: 'frontend.productlist.refresh.' + currentState.controlId,
            initChannelPrefix: 'frontend.productlist.init.' + currentState.controlId,
            readyChannelPrefix: 'frontend.productlist.ready.' + currentState.controlId,

            uniqueFiltersChannelPrefix: 'frontend.productlist.filters.' + currentState.pageControlId,
            uniqueStaticFilterChannelPrefix: 'frontend.productlist.staticfilter.' + currentState.pageControlId,
            uniqueRefreshChannelPrefix: 'frontend.productlist.refresh.' + currentState.pageControlId,
            uniqueInitChannelPrefix: 'frontend.productlist.init.' + currentState.pageControlId,
            uniqueReadyChannelPrefix: 'frontend.productlist.ready.' + currentState.pageControlId,
// ReSharper restore StringLiteralTypo
        }

        return {
            init: function () {
                initProductControls(model, controls, currentState, pubSubEventNames);

                reportImpressions(model, controls);

                var initialTerm = $.trim(controls.$searchInput.val());
                if (initialTerm && initialTerm.length >= 3) {
                    search(model, controls, currentState, pubSubEventNames, initialTerm);
                }

                // Subscribe to removeFromCart event and hide shopCart icon
// ReSharper disable StringLiteralTypo
                root.PublicEStore.subscribe('estore.callback.shopcart.removefromcart', removeFromCartCallback);
                root.PublicEStore.subscribe('estore.callback.shopcart.emptycart', emptyCartCallback);
                root.PublicEStore.subscribe('estore.callback.shopcart.addtocart', addToCartGlobalCallback);
                root.PublicEStore.subscribe('estore.callback.shopcart.updatecartquantity', updateCartGlobalCallback);
// ReSharper restore StringLiteralTypo

                setupViewSettings();
                if (controls.$campaignFragmentContainer.length > 0) {

                    // Hide paging for campaigns. Campaigns should be valid for the initial load only.
                    controls.$viewSettings.hide();
                } else {
                    controls.$viewSettings.show();
                    setupPaging(model, controls, currentState, pubSubEventNames);
                }

                // Filters
                if (!model.skipFilterEvents) {
                    pubSub.subscribe(pubSubEventNames.filtersChannelPrefix + '.apply', filterCallback);
                    pubSub.subscribe(pubSubEventNames.uniqueFiltersChannelPrefix + '.apply', filterCallback);

                    pubSub.subscribe(pubSubEventNames.filtersChannelPrefix + '.sortingchanged', sortingChangedCallback);
                    pubSub.subscribe(pubSubEventNames.uniqueFiltersChannelPrefix + '.sortingchanged', sortingChangedCallback);

                    pubSub.subscribe(pubSubEventNames.staticFilterChannelPrefix + '.apply', onStaticFilterApplyChannel);
                    pubSub.subscribe(pubSubEventNames.uniqueStaticFilterChannelPrefix + '.apply', onStaticFilterApplyChannel);

                    pubSub.subscribe(pubSubEventNames.staticFilterChannelPrefix + '.reset', onStaticFilterResetChannel);
                    pubSub.subscribe(pubSubEventNames.uniqueStaticFilterChannelPrefix + '.reset', onStaticFilterResetChannel);

                    function onStaticFilterApplyChannel(topic, data) {
                        currentState.page = 1;
                        currentState.filteredCategoryIDs = data.selectedIds;
                        refreshProductList(model, controls, currentState, pubSubEventNames, false, true, false, false, false);
                    }

                    function onStaticFilterResetChannel() {
                        currentState.page = 1;
                        currentState.filteredCategoryIDs = null;
                        refreshProductList(model, controls, currentState, pubSubEventNames, false, true, false, false, false);
                    }
                }

                if (model.enableHistoryState) {
                    // Set initial state
                    root.history.replaceState(currentState, '', null);
                    // Subscribe to popstate event
                    $(root).on('popstate', onHistoryPopState);
                }

                pubSub.publish(pubSubEventNames.readyChannelPrefix);
                pubSub.publish(pubSubEventNames.uniqueReadyChannelPrefix);

                function filterCallback(topic, filterState) {
                    if (filterState.isPreApplied === true) {
                        if (currentState.isPreAppliedFilterProcessed) {
                            return;
                        }
                        currentState.isPreAppliedFilterProcessed = true;
                    }

                    var totalItemsAfterFiltersApplied = typeof (filterState.filteredItemIds) !== 'undefined' && filterState.filteredItemIds !== null
                        ? filterState.filteredItemIds.length
                        : currentState.totalItemsInDataSource;

                    // reset paging
                    if (!filterState.isRestoring) {
                        currentState.page = 1;
                    }
                    currentState.totalItems = totalItemsAfterFiltersApplied;
                    // apply filters
                    currentState.filteredItemIds = filterState.filteredItemIds;
                    currentState.filtersUrl = filterState.filtersUrl;
                    currentState.appliedFilters = filterState.appliedFilters;
                    currentState.showOnlyInStock = filterState.showOnlyInStock;

                    refreshProductList(model, controls, currentState, pubSubEventNames, filterState.isHistoryPopEvent !== true, true, true, false, false);
                }

                function sortingChangedCallback(topic, sortBy) {
                    currentState.sort = sortBy;
                    refreshProductList(model, controls, currentState, pubSubEventNames, true, false, true, false, false);
                }

                function removeFromCartCallback(topic, dataContract) {
                    _.each(dataContract.result.items, function (prod) {
                        if (prod.status.toLowerCase() === 'ok') {
                            var $prodContainer = controls.$productContainers.filter('[data-productid="' + prod.productID + '"]');
                            if ($prodContainer) {
                                $prodContainer.find('.js-add-to-cart').hide();
                                disableQuantityEditMode(controls, $prodContainer);
                            }
                        }
                    });
                }

                function emptyCartCallback(topic, dataContract) {
                    if (dataContract.status.toLowerCase() === 'ok') {
                        controls.$productListContainer.find('.js-add-to-cart').hide();
                        controls.$productContainers.each(function () {
                            disableQuantityEditMode(controls, $(this));
                        });
                    }
                }

                function addToCartGlobalCallback(topic, contract) {
                    _.each(contract.result.items, function (prod) {
                        if (prod.status.toLowerCase() === 'ok') {
                            var $prodContainer = controls.$productContainers.filter('[data-productId="' + prod.productID + '"]');
                            updateProdCardQuantity($prodContainer, prod.totalQuantityInTempOrderLine);

                            enableQuantityEditMode($prodContainer, prod.tempOrderLineID);
                        }
                    });
                }

                function updateCartGlobalCallback(topic, contract) {
                    _.each(contract.result.items, function (prod) {
                        if (prod.status.toLowerCase() === 'ok') {
                            var $prodContainer = controls.$productContainers.filter('[data-productId="' + prod.productID + '"]');

                            updateProdCardQuantity($prodContainer, prod.quantity);
                        }
                    });
                }

                function updateProdCardQuantity($prodContainer, prodQuntity){
                    // Update or Add total product's count for the current temp order line
                    var orderLineQuantityContainer = $prodContainer.find('.js-prod-count');
                    orderLineQuantityContainer.show();
                    orderLineQuantityContainer.text(prodQuntity);

                    // Animate action
                    var $addToCartIconContainer = $prodContainer.find('.js-add-to-cart');
                    if ($addToCartIconContainer.length > 0 && prodQuntity > 0) {
                        $addToCartIconContainer.show();
                        $prodContainer.effect('transfer', { to: $addToCartIconContainer }, 500, function () {
                            $addToCartIconContainer.effect('bounce', null, 500);
                        });
                    } else {
                        $addToCartIconContainer.hide();
                    }
                }

                function setupViewSettings() {
                    // Setup items per page changes
                    controls.$perPageItems.change(function (evt) {
                        currentState.perPage = parseInt(evt.target.value);
                        // Reset current page index
                        currentState.page = 1;
                        refreshProductList(model, controls, currentState, pubSubEventNames, true, true, true, false, false);
                    });
                }

                function onHistoryPopState(evt) {
                    var state = evt.originalEvent.state;
                    if (state && state.controlId === currentState.controlId) {
                        // Restore target state
                        currentState = state;
                        refreshProductList(model, controls, currentState, pubSubEventNames, false, true, true, false, false);
                    }
                }
            }
        }
    }

    function createProductListController(productListContext) {
        if (productListContext) {
            var mainPanelId = productListContext.mainPanelID;
            var $mainPanel = $('#' + mainPanelId);

            if ($mainPanel.length === 1) {
                return new productListController($mainPanel, productListContext);
            } else if ($mainPanel.length === 0) {
                console.warn(assetId + ': product list main panel element was not found by id#' + mainPanelId);
            } else {
                console.warn(assetId + ': found > 1 product list main panel elements with id#' + mainPanelId);
            }
        }
        return null;
    }

    root.createProductListController = createProductListController;

    $(function () {
        if (root.umwAssets && root.umwAssets[assetId]) {
            root.umwAssets[assetId].forEach(function (ctx) {
                var controller = createProductListController(ctx);
                if (controller) {
                    controller.init();
                }
            });
        }
    });

    function initProductControls(model, controls, currentState, pubSubEventNames) {
        controls.init();

        controls.$productContainers.find('.' + classes.buyBtn).click(onBuyButtonClick);
        controls.$productContainers.find('.WishListBtn').click(onWishListButtonClick);
        controls.$productContainers.find('.QuantityDrp').change(onQuantityChanged);
        controls.$productContainers.find('.ShoppingListBtn').click(onShoppingListButtonClick);
        controls.$productContainers.find('.' + classes.quickView).click(onQuickViewButtonClick);
        controls.$productContainers.find('.' + classes.editQtyBtn).click(onEditQtyButtonClick);
        controls.$productContainers.find('.' + classes.modifyQtyBtn).click(onQuantityModifyButtonClick);
        controls.$productContainers.find('.' + classes.overlayBtn).click(onOverlayBtn);
        controls.$productContainers.find('.' + classes.hideOverlayBtn).click(onHideOverlayBtn);

        if (model.showCategoriesInfo) {
            setupCategoriesInfo();
        }

        if (model.showDimensionsInStockInfo) {
            // Build dimension stock info for single dimension products
            setupDimensionsInStockOverlay();
        }

        setupDimensionChoices();

        function setupCategoriesInfo() {
            const $productItems = controls.$productListContainer.find('.js-uc193-item');
            const productItemIds = $productItems.map(function () { return $(this).data(dataNames.itemId); }).get();

            $.post(productsHandlerUrl, {
                action: 'getProductsCategoriesInfo',
                itemIds: JSON.stringify(productItemIds),
                rootCategories: JSON.stringify(model.categoriesInfoRootCategories),
                iconImageWidth: model.categoryInfoIconImageWidth
            }).done((productsCategoriesMap) => {
                _.each(productsCategoriesMap, (categoriesInfo, currentItemId) => {
                    if (categoriesInfo) {
                        const currentProductCategoriesInfoComponent = document.querySelectorAll('cms-category-info[data-itemid="' + currentItemId + '"]')[0];
                        currentProductCategoriesInfoComponent.render(categoriesInfo);
                    }
                })
            })
            .fail(() => {
                console.error('Failed to load products categories info');
            });
        }

        pubSub.publish(pubSubEventNames.initChannelPrefix, { controlId: currentState.controlId, mainPanelId: model.mainPanelID });
        pubSub.publish(pubSubEventNames.uniqueInitChannelPrefix, { controlId: currentState.controlId, mainPanelId: model.mainPanelID });

        function onBuyButtonClick(evt) {
            evt.preventDefault();
            var $prodContainer = $(this).closest('.' + classes.prodItem);

            var tempOrderLineId = $prodContainer.data(dataNames.tempOrderLineId);
            var quantity = $.mw_tryParseIntStrict(getSelectedProductQuantity($prodContainer));

            var deferred = [];

            if (isQuantityEditModeEnabled($prodContainer) && quantity === 0 && tempOrderLineId) {
                var removeFromCartContract = getRemoveFromCartContract($prodContainer, tempOrderLineId);
                deferred.push(root.PublicEStore.removeFromCart(removeFromCartContract));
            } else {
                var addToCartContract = getAddToCartContract($prodContainer);
                deferred.push(root.PublicEStore.addToCart(addToCartContract));
            }

            if (deferred.length) {
                $prodContainer.addClass('buying');
                $.when.apply($, deferred)
                    .done(successCallback)
                    .fail(errorCallback).always(function() {
                        $prodContainer.removeClass('buying');
                    });
            }

            function successCallback(dataContract) {
                _.each(dataContract.result.items, function (prod) {
                    if (prod.status.toLowerCase() !== 'ok') {
                        notify(prod.message, 'error');
                    }
                });
            }

            function errorCallback(dataContract) {
                if (dataContract.status.toLowerCase() === 'unauthorized') {
                    pubSub.publish('notification.warning', { text: model.labels.availableToRegisteredOnly + '<br /><a href="' + currentState.loginUrl + '">' + model.labels.loginToContinue + '</a>', layout: 'center', killer: true, modal: true, timeout: false });
                } else if (dataContract.result) {
                    _.each(dataContract.result.items, function (prod) {
                        notify(prod.message, 'error');
                    });
                }
            }
        }
        function onWishListButtonClick(evt) {
            var $wishListControl = $(this);
            var needsAdditionalInputToBuy = $wishListControl.hasClass('NeedsAdditionalInputToBuy');
            if (needsAdditionalInputToBuy) {
                return;
            }

            evt.preventDefault();

            var isAddToWishListAction = $wishListControl.hasClass('Add');
            var productId = $wishListControl.closest('.' + classes.prodItem).data(dataNames.productId);
            window.updateWishList(productId, isAddToWishListAction ? 'add' : 'remove', wishListCallback);

            function wishListCallback(dataContract) {
                if (dataContract.status.toLowerCase() === 'ok') {
                    _.each(dataContract.result.items,
                        function (prod) {
                            if (prod.status.toLowerCase() === 'ok') {
                                notify(model.labels.wishListUpdated, 'success');

                                $wishListControl.toggleClass('Add', !isAddToWishListAction);
                                $wishListControl.toggleClass('Remove', isAddToWishListAction);
                            } else {
                                notify(prod.message, 'error');
                            }
                        });
                } else {
                    notify(dataContract.message, dataContract.status);
                }
            }
        }
        function onQuantityChanged() {
            if (model.multPriceByQuantity) {
                var $prodContainer = $(this).closest('.' + classes.prodItem);
                var productId = $prodContainer.data(dataNames.productId);
                var quantity = getSelectedProductQuantity($prodContainer);

                var cacheKey = 'quantityPrices_' + productId + '_' + quantity;
                if (cacheKey in currentState.dataCache) {
                    var productListItem = currentState.dataCache[cacheKey];
                    updateDisplayedPrices($prodContainer, productListItem);
                } else {

                    blockUI();

                    var query = {
                        action: 'GetProductQuantityPrice',
                        controlId: currentState.controlId,
                        pageId: root.BasePageID,
                        productId: productId,
                        quantity: quantity
                    };

                    $.get(productsHandlerUrl, query)
                        .done(function (productListItem) {
                            currentState.dataCache[cacheKey] = productListItem;
                            updateDisplayedPrices($prodContainer, productListItem);
                        })
                        .fail(function (errResp) {
                            var message;
                            if (typeof (errResp) === 'object') {
                                // Extract error message
                                var responseObj = JSON.parse(errResp.responseText);
                                message = responseObj.Message ? responseObj.Message : errResp.statusText;
                            } else {
                                message = errResp;
                            }
                            notify(model.labels.failedToLoadProductList + '<br />' + message, 'error');
                        })
                        .always(unblockUI);
                }
            }

            function updateDisplayedPrices($prodContainer, productListItem) {
                if (productListItem.DiscountPrice) {
                    $prodContainer.find('.DiscountPriceRow .DiscountPrice.Value').text(productListItem.DiscountPriceString);
                }
                if (productListItem.Price) {
                    if (productListItem.OriginalPrice) {
                        $prodContainer.find('.PriceRow .OriginalPrice.Value').text(productListItem.OriginalPriceString);
                    }
                    $prodContainer.find('.PriceRow .Price').not('.WithVAT,.WithoutVAT').text(productListItem.PriceString);
                }
                if (productListItem.PriceWithoutVAT) {
                    if (productListItem.OriginalPrice) {
                        $prodContainer.find('.PriceRow .OriginalPrice.Value').text(productListItem.OriginalPriceString);
                    }
                    $prodContainer.find('.PriceRow .Price.WithoutVAT').text(productListItem.PriceWithoutVATString);
                }
                if (productListItem.PriceWithVAT) {
                    if (productListItem.OriginalPrice) {
                        $prodContainer.find('.PriceRow .OriginalPrice.Value').text(productListItem.OriginalPriceString);
                    }
                    $prodContainer.find('.PriceRow .Price.WithVAT').text(productListItem.PriceWithVATString);
                }
                if (productListItem.Price2) {
                    $prodContainer.find('.Price2Row .Price2.Value').text(productListItem.Price2String);
                }
                if (productListItem.Price3) {
                    $prodContainer.find('.Price3Row .Price3.Value').text(productListItem.Price3String);
                }
            }
        }
        function onShoppingListButtonClick(evt) {
            evt.preventDefault();

            var $shoppingListButton = $(this);
            var $prodContainer = $shoppingListButton.closest('.' + classes.prodItem);
            var productToAdd = getAddToCartContract($prodContainer);
            root.showAddToCollectionPopup([productToAdd]);
        }
        function onQuickViewButtonClick(evt) {
            evt.preventDefault();

            var $prodContainer = $(this).closest('.' + classes.prodItem);
            var productId = $prodContainer.data(dataNames.productId);

            var query = {
                action: 'GetQuickView',
                controlId: currentState.controlId,
                pageId: root.BasePageID,
                productId: productId
            };

            blockUI();

            $.get(productsHandlerUrl, query)
                .always(unblockUI)
                .done(function (quickViewData) {
                    var quickViewHtml = quickViewData.html;
                    var quickViewModel = quickViewData.model;

                    if (quickViewHtml) {
                        showQuickViewPopup(quickViewHtml, quickViewModel);
                    } else {
                        reportQuickViewFail();
                    }
                })
                .fail(reportQuickViewFail);

            function reportQuickViewFail() {
                notify(model.labels.failedToLoadQuickView, 'error');
            }

            function showQuickViewPopup(quickViewHtml, quickViewModel) {
                $.fancybox.open({
                    src: quickViewHtml,
                    type: 'html',
                    opts: {
                        parentEl: "form:first",
                        afterLoad: function (instance, current) {
                            if (typeof root.productViewController !== 'function')
                                console.error('Product view main asset is not loaded');

                            var quickViewController = root.productViewController(current.$content, quickViewModel);
                            quickViewController.init();

                            if (typeof root.customFieldsController === 'function') {
                                var customFieldsController = root.customFieldsController();
                                customFieldsController.init();
                            }
                        }
                    }
                });
            }
        }
        function onEditQtyButtonClick(evt) {
            var $prodContainer = $(this).closest('.' + classes.prodItem);

            evt.preventDefault();

            var productId = $prodContainer.data(dataNames.productId);

            var query = {
                action: 'getProductCartInfo',
                productId: productId
            };

            blockUI();

            $.get(productsHandlerUrl, query)
                .always(unblockUI)
                .done(function (productCartInfo) {
                    if (productCartInfo) {
                        processProductCartInfo(productCartInfo);
                    }
                })
                .fail(reportProductCartInfoFail);

            function reportProductCartInfoFail() {
                notify('Failed to load product cart info.', 'error');
            }

            function processProductCartInfo(productCartInfo) {
                $prodContainer.data(dataNames.tempOrderLineId, productCartInfo.tempOrderLineId);
                if (productCartInfo.factor) {
                    $prodContainer.find('.' + classes.quantityInput).val(productCartInfo.factorQuantity);
                    $prodContainer.find('.' + classes.fractionInput).val(productCartInfo.fractionQuantity);
                } else {
                    $prodContainer.find('.' + classes.quantityInput).val(productCartInfo.inCartQuantity);
                }
            }
        }
        function onQuantityModifyButtonClick(evt) {
            evt.preventDefault();

            const $this = $(this);

            const dataAttributes = {
                actionType: $this.data('action'),
                quantityTxbId: $this.data('target')
            };

            const $quantityInput = $this.parent().find(dataAttributes.quantityTxbId);

            const quantityString = $quantityInput.val();
            let quantity = parseFloat(quantityString.replace(',', '.'));

            const quantityMinValString = $quantityInput.attr('min');
            const quantityDataMinValString = $quantityInput.data('min')?.toString();
            const quantityMinVal = quantityMinValString ?
                parseFloat(quantityMinValString.replace(',', '.'))
                : quantityDataMinValString ?
                    parseFloat(quantityDataMinValString.replace(',', '.'))
                    : 1;

            switch (dataAttributes.actionType) {
            case 'decrease':
                if (quantity > quantityMinVal)
                    quantity = --quantity;
                break;
            case 'increase':
                quantity = ++quantity;
                break;
            }

            if (quantity < quantityMinVal) {
                $quantityInput.val(quantityMinVal.toLocaleString());
            } else {
                quantity = Math.round(quantity * 10) / 10;
                $quantityInput.val(quantity.toLocaleString());
            }

            $quantityInput.trigger('change');
        };
        function onOverlayBtn() {
            var $prodContainer = $(this).closest('.' + classes.prodItem);
            hideOverlaysExcept(controls, $prodContainer);
            $prodContainer.addClass('show-overlay');
        }
        function onHideOverlayBtn() {
            var $prodContainer = $(this).closest('.' + classes.prodItem);
            $prodContainer.removeClass('show-overlay');
        }

        function setupDimensionsInStockOverlay() {
            var $singleDimensionProducts = controls.$productListContainer.find('.SingleDimensionProduct');
            var singleDimensionItemIds = $singleDimensionProducts.map(function () { return $(this).data(dataNames.itemId); }).get();

            $.post(productsHandlerUrl, {
                    action: 'GetAvailableDimensionProducts',
                    itemIds: JSON.stringify(singleDimensionItemIds)
                })
                .done(function (availableDimProductsMap) {
                    _.each(availableDimProductsMap, function (availableDimProducts, currentItemId) {
                        var $currentProductContainer = $singleDimensionProducts.filter('[data-itemid="' + currentItemId + '"]');
                        var $currentDimensionsInStockContainer = $currentProductContainer.find('.js-dimensions-in-stock');

                        var $dimensionsStockContent;
                        if (availableDimProducts && availableDimProducts.length > 0) {
                            $dimensionsStockContent = $('<div class="DimensionsInStockHeader">' + model.labels.dimensionsInStock + '</div><div class="DimensionsInStockContent"></div>');

                            availableDimProducts = sortDimProds(availableDimProducts);

                            availableDimProducts.forEach(function (dimProduct) {
                                var dimName = dimProduct.dimensions[0].STPD_SysName;
                                var dimProdLink = dimProduct.dimensionLinks[0];
                                if (dimName && dimProdLink) {
                                    $($dimensionsStockContent[1]).append('<a href="' + dimProdLink + '" class="DimensionsInStockLink" tabindex="-1">' + dimName + '</a>');
                                }
                            });

                        } else {
                            $dimensionsStockContent = $('<div class="DimensionsInStockHeader OutOfStock">' + model.labels.dimensionsOutOfStock + '</div>');
                        }
                        // Place it in own container
                        if ($currentDimensionsInStockContainer.length === 1) {
                            $currentDimensionsInStockContainer.prepend($dimensionsStockContent).addClass('show');
                        }
                    });
                })
                .fail(function () {
                    console.error('Failed to load available dimensions');
                });

            function sortDimProds(availableDimProds) {
                var sizeMap = ['xxs', '2xs', 'xx-small', 'xs', 'x-small', 's', 'small', 'm', 'medium', 'l', 'large', 'xl', 'x-large', 'xxl', '2xl', 'xx-large', 'xxxl', '3xl', 'xxx-large', '4xl', '5xl'];

                return _.sortBy(availableDimProds, function (dimProd) {
                    var variantName = (typeof (dimProd.dimensions[0].STPD_SysName.normalize) === 'function' ? dimProd.dimensions[0].STPD_SysName.normalize() : dimProd.dimensions[0].STPD_SysName).replace(/[\s,]/g, '').toLowerCase();

                    if ($.isNumeric(variantName)) {
                        return parseFloat(variantName);
                    }

                    var positionInSize = _.indexOf(sizeMap, variantName);

                    return positionInSize !== -1 ? positionInSize : undefined;
                });
            }
        }
        function setupDimensionChoices() {
            var $prodContainer;
            var $mainImage;
            // ReSharper disable once InconsistentNaming
            var mainImageURL;
            var dimImageUrl;
            $('.' + classes.dimItem).hover(
                function () {
                    $prodContainer = $(this).closest('.' + classes.prodItem);
                    $mainImage = $prodContainer.find('.' + classes.mainImage);
                    mainImageURL = $prodContainer.find('.' + classes.mainImage).attr('src');
                    dimImageUrl = $(this).data('main-img-src');
                    if ($mainImage.length && dimImageUrl) {
                        $mainImage.attr('src', dimImageUrl);
                    }
                },
                function () {
                    $mainImage.attr('src', mainImageURL);
                }
            );
        }

        var $searchBtn = $('.js-product-list-search').find('.js-product-list-search-btn');
        $searchBtn.unbind().on('click',
            function (e) {
                e.preventDefault();
                var term = $.trim(controls.$searchInput.val());
                if (term) {
                    search(term);
                }
            });


        controls.$searchInput.autocomplete({
            minLength: 3,
            source: function () {
                $searchBtn.trigger('click');
            }
        }).one('keypress',
            function (e) {
                var term = $.trim(controls.$searchInput.val());
                if (e.keyCode == 13) {
                    e.preventDefault();
                    search(term);
                }
            });

        controls.$searchInput.keyup(function () {
            if (!this.value) {
                controls.$productListContainer.html($(document.createElement('h3')).text(model.labels.enterSearchQuery).addClass(currentState.controlId.toString().toLowerCase() + ' __no-products-msg'));
                controls.$pagingControls.find('.ProductListPager').remove();
            } else if (this.value.length < 3) {
                controls.$productListContainer.html($(document.createElement('h3')).text(model.labels.noProductsFound).addClass(currentState.controlId.toString().toLowerCase() + ' __no-products-msg'));
                controls.$pagingControls.find('.ProductListPager').remove();
            }
        });

    };

    function search(model, controls, currentState, pubSubEventNames, term) {
        if (currentState.timer) {
            window.clearTimeout(currentState.timer);
            currentState.timer = null;
        }

        currentState.timer = window.setTimeout(function () {
            currentState.searchTerm = term;
            refreshProductList(model, controls, currentState, pubSubEventNames, false, true, false, true, false);
        }, 500);
    }

    function refresh(model, controls, currentState, pubSubEventNames, needPublish, dontBlockUi, callback) {
        if (!dontBlockUi) blockUI();

        var query = {
            action: 'GetProductList',
            pageId: root.BasePageID,
            itemId: root.BaseItemID,
            orderId: model.orderId,
            controlId: currentState.controlId,
            pagecontrolid: currentState.pageControlId,
            perPage: currentState.perPage,
            page: currentState.page,
            sort: currentState.sort,
            filteredItemIds: JSON.stringify(currentState.filteredItemIds),
            filteredCategoryIDs: JSON.stringify(currentState.filteredCategoryIDs),
            s: currentState.searchTerm,
            isProductPage: currentState.isProductPage,
            showOnlyInStock: currentState.showOnlyInStock
        };

        $.post(productsHandlerUrl, query)
            .done(function (productListData) {
                //note: total items count may change when 'show only in stock' is changed
                currentState.totalItems = productListData.totalItemsCount;
                if (productListData.totalItemsCount > 0) {
                    controls.$productListContainer.html(productListData.productListHtml);
                } else {
                    controls.$productListContainer.html($(document.createElement('h3')).text(model.labels.noProductsFound).addClass(currentState.controlId.toString().toLowerCase() + ' __no-products-msg'));
                }

                $('.js-search-statistics').text(productListData.totalStatistics);

                initProductControls(model, controls, currentState, pubSubEventNames);

                if (productListData.totalItemsCount > 0 && controls.$productListContainer.find('.lipscore-rating-small').length && lipscore) {
                    lipscore.reInitWidgets();
                }

                if (callback && typeof (callback) === 'function') {
                    callback.apply(this);
                }

                reportImpressions(model, controls);

                if (needPublish) {
                    pubSub.publish(pubSubEventNames.refreshChannelPrefix, { showOnlyInStock: currentState.showOnlyInStock });
                    pubSub.publish(pubSubEventNames.uniqueRefreshChannelPrefix, { showOnlyInStock: currentState.showOnlyInStock });
                }
            })
            .fail(function (errResp) {
                var message;
                if (typeof (errResp) === 'object') {
                    // Extract error message
                    var responseObj = JSON.parse(errResp.responseText);
                    message = responseObj.Message ? responseObj.Message : errResp.statusText;
                } else {
                    message = errResp;
                }
                notify(model.labels.failedToLoadProductList + '<br />' + message, 'error');
            })
            .always(unblockUI);
    }

    function setupPaging(model, controls, currentState, pubSubEventNames) {
        if (controls.$pagingControls.length > 0) {
            var perPage = currentState.perPage;
            var totalItems = currentState.totalItems;
            var showViewAll = currentState.showViewAll;
            // This will re-init paging controls
            controls.$pagingControls.find('.ProductListPager').remove();
            controls.$pagingControls.html('<ul class="ProductListPager"></ul>');

            if (perPage > 0 && totalItems > perPage) {
                var $listPager = controls.$pagingControls.find('.ProductListPager');
                $listPager.twbsPagination({
                    totalPages: Math.ceil(totalItems / perPage),
                    visiblePages: model.shownPages,
                    startPage: currentState.page,
                    first: model.labels.first,
                    next: model.labels.next,
                    prev: model.labels.prev,
                    last: model.labels.last,
                    onPageClick: pagingChangedCallback
                });

                if (showViewAll) {
                    var $viewAllItem = $('<li class="show-all"><a href="#">' + model.labels.viewAll + '</a></li>');
                    $viewAllItem.click(viewAllClicked);
                    $listPager.append($viewAllItem);
                }
            }
        }

        function pagingChangedCallback(event, page) {
            if (currentState.showViewAll) {
                //note: re-adding ViewAll item because it is removed by pagination plugin on page change
                var $viewAllItem = $('<li class="show-all"><a href="#">' + model.labels.viewAll + '</a></li>');
                $viewAllItem.click(viewAllClicked);
                controls.$pagingControls.find('.ProductListPager').append($viewAllItem);
            }
            currentState.page = page;
            refreshProductList(model, controls, currentState, pubSubEventNames, true, false, true, false, true);
        }

        function viewAllClicked() {
            currentState.perPage = -1;
            // Reset current page index
            currentState.page = 1;
            refreshProductList(model, controls, currentState, pubSubEventNames, true, true, true, false, false);
        }
    }

    function onUpdateHistory(model, currentState) {
        // Update history
        if (root.history) {
            var newStateUrl = location.href.split('#')[0];

            var state = currentState;

            if (model.enableHistoryState) {
                if (state.sort)
                    newStateUrl = $.setQueryStringParam(newStateUrl, 'sort_' + state.controlId, state.sort);

                if (state.page)
                    newStateUrl = $.setQueryStringParam(newStateUrl, 'page_' + state.controlId, state.page);

                if (state.perPage)
                    newStateUrl = $.setQueryStringParam(newStateUrl, 'perpage_' + state.controlId, state.perPage);

                newStateUrl = state.showOnlyInStock
                    ? $.setQueryStringParam(newStateUrl, 'instockonly_' + state.controlId, 'true')
                    : $.removeQueryStringParam(newStateUrl, 'instockonly_' + state.controlId);

                if (state.filtersUrl)
                    newStateUrl += '#' + state.filtersUrl;

                if (newStateUrl !== location.href && typeof (root.history.pushState) !== 'undefined')
                    root.history.pushState(state, '', newStateUrl);
            } else {
                if (state.filtersUrl)
                    newStateUrl += '#' + state.filtersUrl;

                if (newStateUrl !== location.href && typeof (root.history.replaceState) !== 'undefined')
                    root.history.replaceState(state, '', newStateUrl);
            }
        }
    }

    function refreshProductList(model, controls, currentState, pubSubEventNames, updateHistory, updatePagers, needPublish, dontBlockUi, scrollToTop) {
        refresh(model, controls, currentState, pubSubEventNames, needPublish, dontBlockUi, function () {
            controls.$viewSettings.show();
            if (updatePagers) {
                setupPaging(model, controls, currentState, pubSubEventNames);
            }
            if (updateHistory) {
                onUpdateHistory(model, currentState);
            }
            if (scrollToTop) {
                tryScrollToTop(controls);
            }
        });
    }

    function tryScrollToTop(controls) {
        if (controls.$productContainers && controls.$productContainers.length) {
            try {
                var firstProd = controls.$productContainers[0];
                var rect = firstProd.getBoundingClientRect();
                if (rect.top < 0) {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    });
                }
            } catch (e) {
                console.error(e);
            }
        }
    }

    function reportImpressions(model, controls) {
        controls.$mainPanel.find('.js-fragment-container').each(function () {
            var $fragment = $(this);

            try {
                var listName = getFragmentTitle($fragment);
                var productImpressions = [];

                $fragment.find('.' + classes.prodItem).each(function () {
                    var $prod = $(this);

                    var productId = parseInt($prod.data(dataNames.productId));
                    if (productId > 0) {
                        productImpressions.push({ productId: productId, $links: $prod.find('.js-product-link') });
                    }
                });

                if (productImpressions.length > 0) {
                    const productListType = root.toProductListType(model.mode);
                    root.reportProductListView(productListType, listName, productImpressions);
                }
            } catch (e) {
                console.error('Failed to report fragment\'s products impressions. ' + e);
            }
        });

        function getFragmentTitle($fragment) {
            var title = $fragment.data('listname') || controls.$mainPanel.find('.MainTitle').text() || document.title;
            return $.trim(title);
        }
    }

    //#region Helpers
    function enableQuantityEditMode($prodContainer, tempOrderLineId) {
        $prodContainer.data(dataNames.tempOrderLineId, tempOrderLineId);
        setQuantityEditModeButtonsState($prodContainer, 'enabled');
    }
    function disableQuantityEditMode(controls, $prodContainer) {
        $prodContainer.data(dataNames.tempOrderLineId, null);
        setQuantityEditModeButtonsState($prodContainer, 'disabled');
        hideOverlays(controls);
    }
    function setQuantityEditModeButtonsState($prodContainer, state) {
        var $editQtyBtn = $prodContainer.find('.' + classes.editQtyBtn),
            $editQtyBtnReplacer = $prodContainer.find('.' + classes.editQtyBtnReplacer),
            $buyBtnLblBuy = $prodContainer.find('.js-lbl-buy'),
            $buyBtnLblEdit = $prodContainer.find('.js-lbl-edit');

        if (state === 'enabled') {
            $editQtyBtn.show();
            $editQtyBtnReplacer.hide();
            $buyBtnLblBuy.hide();
            $buyBtnLblEdit.show();
        } else {
            $editQtyBtn.hide();
            $editQtyBtnReplacer.show();
            $buyBtnLblBuy.show();
            $buyBtnLblEdit.hide();
        }
    }
    function isQuantityEditModeEnabled($prodContainer) {
        return $prodContainer.data(dataNames.quantityEditMode) === 'enabled';
    }
    function hideOverlays(controls) {
        controls.$productListContainer.find('.' + classes.prodItem).removeClass('show-overlay');
    }
    function hideOverlaysExcept(controls, $prodContainer) {
        controls.$productListContainer.find('.' + classes.prodItem).not($prodContainer).removeClass('show-overlay');
    }
    function getSelectedProductQuantity($prodContainer) {
        return $prodContainer.find('.' + classes.quantityInput + ',.QuantityDrp').val();
    }
    function getAddToCartContract($prodContainer) {
        var customFields = {};
        $prodContainer.find('.customFieldsCont .customField').each(function (idx, elem) {
            var $elem = $(elem);
            var customFieldId = $elem.attr('customFieldId');

            //Special handling for checkbox because they are wrapped in a span
            if ($elem.find('input').length > 0) {
                $elem = $elem.find('input');
            }

            if (customFieldId) {
                var cfValue = $elem.is(':checkbox') ? $elem.is(':checked').toString() : $elem.val();
                customFields[customFieldId] = cfValue;
            }
        });

        var addToCartContract = {
            productId: $prodContainer.data(dataNames.productId),
            imageId: $prodContainer.data(dataNames.imageId),
            quantity: getSelectedProductQuantity($prodContainer),
            fraction: $prodContainer.find('.' + classes.fractionInput).val(),
            customFields: customFields
        };

        var tempOrderLineId = $prodContainer.data(dataNames.tempOrderLineId);
        if (isQuantityEditModeEnabled($prodContainer) && tempOrderLineId) {
            addToCartContract.tempOrderLineId = tempOrderLineId;
        }

        return addToCartContract;
    }
    function getRemoveFromCartContract($prodContainer, tempOrderLineId) {
        var removeFromCartContract = {
            productId: $prodContainer.data(dataNames.productId),
            tempOrderLineId: tempOrderLineId,
        };

        return removeFromCartContract;
    }
    function notify(message, type) {
        var notificationChannel = typeof (type) === 'string' && type ? 'notification.' + type : 'notification';
        pubSub.publish(notificationChannel, message);
    }
    function blockUI() {
        if (typeof ($.blockUI) === 'function') {
            $.blockUI({ message: null });
        }
    }
    function unblockUI() {
        if (typeof ($.unblockUI) === 'function') {
            $.unblockUI();
        }
    }
    //#endregion

})(jQuery, _, window);